import {
  Avatar,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DoneIcon from "@mui/icons-material/Done";
import SearchFanpageForm from "../../../Posts/Components/SearchFanpageForm";

const DialogFilterConversationByFanpage = ({
  state,
  setState,
  onCloseDialog,
  loadMoreFanpage,
  onHandleFilterConversationByFanpage,
}) => {
  const { t } = useTranslation();
  const [fanpages, setFanpages] = useState([]);

  const checkAllOption = {
    fanpage_id: -1,
    name: t("common.all"),
  };
  const handleSearch = (searchTerm) => {
    const filteredFanpages = state.fanpages.filter((fanpage) =>
      fanpage.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFanpages(filteredFanpages);
    setState({ ...state, isSearching: searchTerm.trim() !== "" });
  };

  const handleClearSearch = () => {
    setFanpages(state.fanpages);
    setState({ ...state, isSearching: false });
  };

  const handleSelectAll = (event) => {
    const { checked } = event.target;
    if (checked) {
      setState((prevState) => ({
        ...prevState,
        filter: {
          ...prevState.filter,
          fanpage_ids: [
            checkAllOption.fanpage_id,
            ...prevState.fanpages
              .slice(0, state.limit)
              .map((fanpage) => fanpage.fanpage_id),
          ],
        },
        all_checked: true,
      }));
      return;
    }
    setState((prevState) => ({
      ...prevState,
      filter: { ...prevState.filter, fanpage_ids: [] },
      all_checked: false,
    }));
  };

  const handleChange = (event, value) => {
    const { checked } = event.target;
    if (checked) {
      setState((prevState) => ({
        ...prevState,
        filter: {
          ...prevState.filter,
          fanpage_ids:
            [...prevState.filter.fanpage_ids, value].length ===
            state.fanpages.length
              ? [
                  checkAllOption.fanpage_id,
                  ...prevState.fanpages.map((fanpage) => fanpage.fanpage_id),
                ]
              : [...prevState.filter.fanpage_ids, value],
        },
        all_checked:
          [...prevState.filter.fanpage_ids, value].length ===
          state.fanpages.length,
      }));
      return;
    }
    setState((prevState) => {
      if (state.all_checked) {
        return {
          ...prevState,
          filter: {
            ...prevState.filter,
            fanpage_ids: prevState.filter.fanpage_ids.filter(
              (id) =>
                id.toString() !== value.toString() &&
                id.toString() !== checkAllOption.fanpage_id.toString()
            ),
          },
          all_checked: false,
        };
      }
      return {
        ...prevState,
        filter: {
          ...prevState.filter,
          fanpage_ids: prevState.filter.fanpage_ids.filter(
            (id) => id.toString() !== value.toString()
          ),
        },
      };
    });
  };

  // const handleCloseDialog = () => {
  //   setFanpages(state.fanpages);
  // }

  useEffect(() => {
    if (!state.dialog) {
      const timeout = setTimeout(() => {
        setFanpages(state.fanpages);
      }, 100);

      return () => clearTimeout(timeout);
    }
  }, [state.fanpages, state.dialog]);

  return (
    <Dialog open={state.dialog} fullWidth maxWidth="md" onClose={onCloseDialog}>
      <DialogTitle
        sx={{
          display: "flex",
          flexDirection: "column",
          rowGap: "8px",
        }}
      >
        {t("liveChat.filter.filterConversationByFanpage")}
        <SearchFanpageForm
          onSearch={handleSearch}
          onClear={handleClearSearch}
        />
      </DialogTitle>
      <DialogContent>
        {fanpages.length > 0 ? (
          <Fragment>
            <List
              dense
              sx={{
                width: "100%",
                bgcolor: "background.paper",
                display: "grid",
                gridTemplateColumns: "1fr 1fr", // 2 cột đều nhau
                gap: "8px", // Khoảng cách giữa các item
              }}
            >
              {/* <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr", // 2 cột đều nhau
                gap: "8px", // Khoảng cách giữa các item
              }}
            > */}
              {!state.isSearching && (
                // <FormControlLabel
                //   control={
                //     <Checkbox
                //       checked={state.all_checked}
                //       onChange={(e) => handleSelectAll(e, checkAllOption)}
                //       name="selectAll"
                //     />
                //   }
                //   label={t("common.all")}
                // />
                <ListItem
                  secondaryAction={
                    <Checkbox
                      edge="end"
                      onChange={(e) => handleSelectAll(e, checkAllOption)}
                      checked={state.all_checked}
                    />
                  }
                  disablePadding
                >
                  <ListItemButton
                    onClick={() => {
                      const isChecked = state.all_checked;
                      handleSelectAll({ target: { checked: !isChecked } });
                    }}
                  >
                    <ListItemText primary={t("common.all")} />
                  </ListItemButton>
                </ListItem>
              )}

              {fanpages.slice(0, state.limit).map((fanpage) => (
                <ListItem
                  key={fanpage.fanpage_id}
                  disablePadding
                  secondaryAction={
                    <Checkbox
                      edge="end"
                      checked={
                        state.filter.fanpage_ids.findIndex(
                          (item) => item === fanpage.fanpage_id
                        ) !== -1
                      }
                      onChange={(e) => {
                        handleChange(e, fanpage.fanpage_id);
                      }}
                      // name={item}
                      // value={fanpage}
                    />
                  }
                >
                  <ListItemButton
                    onClick={() => {
                      const isChecked = state.filter.fanpage_ids.includes(
                        fanpage.fanpage_id
                      );
                      handleChange(
                        { target: { checked: !isChecked } },
                        fanpage.fanpage_id
                      );
                    }}
                  >
                    <ListItemAvatar>
                      <Avatar alt={fanpage.name} src={fanpage.image} />
                    </ListItemAvatar>
                    <ListItemText
                      primary={`${fanpage.name} - ${fanpage.fanpage_id}`}
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
            {/* </Box> */}
            {fanpages.length > state.limit && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "16px",
                }}
              >
                <Button
                  // fullWidth
                  className="text-transform"
                  variant="contained"
                  // autoFocus
                  // disabled={state.fanpage_selected.length === 0}
                  onClick={loadMoreFanpage}
                  color="primary"
                >
                  {t("common.seeMore")}
                </Button>
              </Box>
            )}
          </Fragment>
        ) : (
          <Typography textAlign="center" color="textSecondary">
            {state.isSearching
              ? t("common.message.noResultsFound")
              : t("common.message.noData")}
          </Typography>
        )}
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Button
          fullWidth
          startIcon={<DoneIcon />}
          className="text-transform"
          variant="contained"
          // autoFocus
          // disabled={state.filter.fanpage_ids.length === 0}
          onClick={() => {
            // handleCloseDialog();
            onHandleFilterConversationByFanpage();
          }}
          color="primary"
        >
          {t("common.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogFilterConversationByFanpage;
